/* @ngInject */
function ProductsTableController ($rootScope, $scope, $timeout, $translate, $q, ConfirmationModalService, UdsModalService, AssetPreviewService, ProductsFrameService, ToastService) {
  const getEditProductDialogController = () => $q.when(import('../../dialogs/edit-product/edit-product.controller'))
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))

  $scope.flags = {
    selectedCard: null,
    delete: {
      loading: false
    }
  }

  $scope.selectedItems = []

  const api = {
    getEditProductDialogController,
    getAttachInsideTheModuleModalController,
    _checkSortOrder,
    _onImageToAttach,
    _addSelectedItem,
    _removeSelectedItem,
    _addAllSelectedItems,
    _removeAllSelectedItems,
    _setSelectedCard,
    _setAllSelectedCard,
    _setImageUrl,
    _setProductsColumns,
    _onSingleDelete,
    _onMultipleDelete,
    _deleteProducts,
    _handleDeleteProducts,
    _showDefaultError,
    _finallyDeleteProducts,
    _handleAddProductImage
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._setProductsColumns()
  }

  const deregisterSetImageUrl = $scope.$watch('products', () => {
    if ($scope.products?.length) {
      api._setImageUrl()
    }
  })

  $scope.$on('$destroy', () => {
    deregisterSetImageUrl()
  })

  $scope.onCheckboxChange = (event, product) => {
    const checked = event.detail.value

    api._setSelectedCard(product, checked)

    if (checked) {
      return api._addSelectedItem(product)
    }

    api._removeSelectedItem(product)
  }

  $scope.onAddImage = (product) => {
    api.getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents',
          singleAttach: true,
          allowedAssetExtensionsSelection: ['png', 'jpeg', 'jpg'],
          avoidSuccessOnConfirm: true
        },
        onClose: assets => api._onImageToAttach(product, assets)
      })

      attachInsideTheModuleModal.open()
    })
  }

  $scope.onDelete = (isSingle, product) => {
    if (isSingle) {
      return api._onSingleDelete(isSingle, product)
    }

    return api._onMultipleDelete(isSingle, $scope.selectedItems)
  }

  $scope.onEdit = (product) => {
    api.getEditProductDialogController().then(({ EditProductDialogController }) => {
      const editProductDialog = UdsModalService.createModal({
        controller: EditProductDialogController,
        modalName: 'editProductDialog',
        data: {
          product
        }
      })
      editProductDialog.open()
    })
  }

  $scope.getPrice = (price) => {
    const localeToCurrency = {
      'pt-br': 'BRL',
      'en-us': 'USD',
      'es-es': 'EUR'
    }

    const locale = $rootScope.oUser?.locale || 'pt-br'

    const currency = localeToCurrency[String(locale)] || 'BRL'

    const defaultPrice = 0
    const priceValue = parseFloat(price || defaultPrice, 10)

    return priceValue.toLocaleString(locale, { style: 'currency', currency })
  }

  $scope.sortColumnClick = (column) => {
    if (!column.isSortable) {
      return
    }

    $scope.params.skip = 0

    if ($scope.params.$sort === column.name) {
      api._checkSortOrder($scope.params.$order)
    } else {
      $scope.params.$sort = column.name
      $scope.params.$order = 'asc'
    }

    $scope.getProducts()
  }

  $scope.getColumnLabelColor = (column) => {
    const isSorted = $scope.params.$sort === column.name && column.isSortable
    return isSorted ? 'neutralColorLowPure' : 'neutralColorLowMediumLightest'
  }

  $scope.getColumnIconColor = (column, order) => {
    const isSorted = $scope.params.$sort === column.name && $scope.params.$order === order && column.isSortable
    return isSorted ? 'neutralColorLowPure' : 'neutralColorLowMediumLightest'
  }

  $scope.onSelectAll = () => {
    api._addAllSelectedItems()
  }

  $scope.onUnselectAll = () => {
    api._removeAllSelectedItems()
  }

  function _checkSortOrder (orderScope) {
    const orders = {
      asc: () => {
        $scope.params.$order = 'desc'
      },
      desc: () => {
        $scope.params.$order = 'asc'
      }
    }

    orders[orderScope]()
  }

  async function _onImageToAttach (currentProduct, assets) {
    const asset = assets?.[0]

    if (!asset) {
      return
    }

    try {
      await api._handleAddProductImage(currentProduct, asset)
    } catch (error) {
      api._showDefaultError(error)
    }
  }

  function _addSelectedItem (product) {
    $scope.selectedItems.push(product)
  }

  function _removeSelectedItem (product) {
    const index = $scope.selectedItems.findIndex(selectedItem => selectedItem.id === product.id)
    const isSelectedItem = index !== -1

    if (isSelectedItem) {
      $scope.selectedItems.splice(index, 1)
    }
  }

  function _addAllSelectedItems () {
    $scope.selectedItems = $scope.products
    api._setAllSelectedCard(true)
  }

  function _removeAllSelectedItems () {
    $scope.selectedItems = []
    api._setAllSelectedCard(false)
  }

  function _setAllSelectedCard (checked) {
    $scope.products.forEach((card) => {
      card.selected = checked
    })
  }

  function _setSelectedCard (product, checked) {
    $scope.products.forEach((card) => {
      if (card.id === product.id) {
        card.selected = checked
      }
    })
  }

  function _setProductsColumns () {
    $scope.columns = [
      {
        id: 1,
        name: '',
        label: '',
        isSortable: false
      },
      {
        id: 2,
        name: 'image',
        label: $translate.instant('image'),
        isSortable: false
      },
      {
        id: 3,
        name: 'externalId',
        label: $translate.instant('productFrame.externalId'),
        isSortable: true
      },
      {
        id: 4,
        name: 'name',
        label: $translate.instant('name'),
        isSortable: true
      },
      {
        id: 5,
        name: 'brand',
        label: $translate.instant('productFrame.brand'),
        isSortable: true
      },
      {
        id: 6,
        name: 'description',
        label: $translate.instant('description'),
        isSortable: true
      },
      {
        id: 7,
        name: 'price',
        label: $translate.instant('productFrame.price'),
        isSortable: true
      },
      {
        id: 8,
        name: 'otherInformation',
        label: $translate.instant('others'),
        isSortable: true
      },
      {
        id: 9,
        name: 'action',
        label: $translate.instant('action'),
        isSortable: false
      }
    ]
  }

  function _setImageUrl () {
    $scope.products.forEach(product => {
      if (product.assetId) {
        product.imageUrl = AssetPreviewService.getAssetThumbnail(product.assetId)
      }
    })
  }

  function _onSingleDelete (isSingle, product) {
    const productIds = [product.id]

    ConfirmationModalService.createModal({
      title: $translate.instant('productFrame.deleteProductModal.title'),
      description: $translate.instant('productFrame.deleteProductModal.description', { productName: product.name }),
      buttonCancelText: $translate.instant('goBack'),
      buttonConfirmText: $translate.instant('productFrame.deleteProductModal.confirmText'),
      onConfirm: () => api._deleteProducts(isSingle, productIds, product)
    })
  }

  function _onMultipleDelete (isSingle, selectedItems) {
    const productIds = selectedItems.map(selectedItem => selectedItem.id)

    ConfirmationModalService.createModal({
      title: $translate.instant('productFrame.deleteProductModal.title'),
      description: $translate.instant('productFrame.deleteProductModal.multiple.description'),
      buttonCancelText: $translate.instant('goBack'),
      buttonConfirmText: $translate.instant('productFrame.deleteProductModal.confirmText'),
      onConfirm: () => api._deleteProducts(isSingle, productIds)
    })
  }

  async function _deleteProducts (isSingle, productIds, product = null) {
    try {
      await api._handleDeleteProducts(isSingle, productIds, product)
    } catch (error) {
      api._errorDeleteProducts(error)
    } finally {
      api._finallyDeleteProducts()
    }
  }

  async function _handleDeleteProducts (isSingle, productIds, product = null) {
    $scope.flags.delete.loading = true

    await ProductsFrameService.deleteProducts({ productIds })

    if (isSingle) {
      const productName = product?.name
      ToastService.showSuccessToast($translate.instant('productFrame.deleteProductModal.successToast', {
        productName
      }))
    } else {
      ToastService.showSuccessToast($translate.instant('productFrame.deleteProductModal.multiple.successToast'))
    }

    $scope.selectedItems = []
    $rootScope.$emit('productsFrame.refresh')
  }

  function _showDefaultError (error) {
    console.error({ error })
    ToastService.defaultErrorToast()
  }

  function _finallyDeleteProducts () {
    $scope.flags.delete.loading = false
  }

  async function _handleAddProductImage (currentProduct, asset) {
    const productId = currentProduct.id
    const payload = {
      assetId: asset.id
    }

    await ProductsFrameService.updateAssetProduct(productId, payload)
    ToastService.showSuccessToast($translate.instant('productFrame.addImageSuccessToast'))
    $rootScope.$emit('productsFrame.refresh')
  }
}

export { ProductsTableController }
